import { Component, OnDestroy, OnInit } from '@angular/core';
import { LayoutService, NavbarBtn } from 'src/app/layout/layout.service';
import { ThirdPartyService } from '../../third-party.service';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { debounceTime, delay, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { isDate } from 'moment';
import * as moment from 'moment';

@Component({
  selector: 'app-sales-list',
  templateUrl: './sales-list.component.html',
  styleUrls: ['./sales-list.component.scss']
})
export class SalesListComponent {
  loading: boolean = true;
  summaryLoading: boolean = true;
  salesData: any[] = [];
  isSummaryExpanded: boolean = false;
  summary: any;
  isExpandFilter: boolean = false;
  is_openSearch: boolean = false;
  subscription = new Subscription;
  searchKeyword: string = '';
  searchForm: FormGroup;
  filterForm: FormGroup;
  isSearchActive: boolean = false;


  dateFilters: any[] = [
    { label: 'Today', value: 'today' },
    { label: 'Last Week', value: 'week' },
    { label: 'Last Month', value: 'month' },
    { label: 'Custom', value: 'custom' },
  ];

  saleTypeFilters: any[] = [
    { key: 'All', value: '' },
    { key: 'POS', value: 'pos' },
    { key: 'Service', value: 'service' },
    { key: 'Secondhand', value: 'secondhand' },
    { key: 'Online Store', value: 'ecom' },
  ];

  params: {
    skip: number;
    take: number;
    isDateChecked: boolean;
    fromDate: string | null;
    toDate: string | null;
    takeAll: boolean;
    key: string;
    keyWord: string;
    orderStatus: string;
    directBuyNo: string;
    unknownUserKey: string;
    saleType: string;
  } = {
      isDateChecked: true,
      fromDate: moment().subtract(7, 'days').startOf('day').toISOString(),
      toDate: moment().endOf('day').toISOString(),
      takeAll: true,
      skip: 0,
      take: 0,
      key: '',
      keyWord: '',
      orderStatus: 'Delivered',
      directBuyNo: '',
      unknownUserKey: '',
      saleType: ''
    };

  // lazy load vriables
  throttle = 300;
  scrollDistance = 3;
  scrollUpDistance = 1.5;
  isEndOfList = false;
  isLazyloading: boolean = false;

  constructor(
    public layoutService: LayoutService,
    public thirdPartyService: ThirdPartyService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.populateToolbarData();
    this.setSearchForm();
    this.setFilterForms();
    this.getAllOrdersList();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public onScroll() {
    if (!this.isLazyloading && !this.isEndOfList) {
      this.isLazyloading = true;
      this.params.skip += this.params.take;
      this.getAllOrdersList();

    }
  }

  public toggleSummary() {
    this.isSummaryExpanded = !this.isSummaryExpanded;
  }

  public clearSearch() {
    this.params.key = "";
    const searchValue = this.searchForm.get('search')?.value;
    this.searchForm.get('search')?.setValue('');
    if (searchValue) {
      this.getAllOrdersList();
    }
  }

  public applyFilter() {
    this.params.saleType = this.filterForm.get('saleType')!.value;
    const f = this.filterForm.value;

    if (f.date === 'custom') {
      const from = new Date(f.fromDate);
      from.setHours(0, 0, 0, 0);

      const to = new Date(f.toDate);
      to.setHours(23, 59, 59, 999);

      this.params.fromDate = from.toISOString();
      this.params.toDate = to.toISOString();
    }

    console.log(this.params);

    this.getAllOrdersList();
  }

  public clearFilter() {
    this.setFilterForms();
    this.getAllOrdersList();
  }

  private populateToolbarData() {
    this.layoutService.setToolbar({
      title: 'Sales List',
    });

    this.layoutService.setNavbarButtons([
      { action: 'search', state: null, icon: 'search' },
      { action: 'filter', state: null, icon: 'filter_list' },
    ]);

    this.subscription.add(
      this.layoutService.buttonClicked$.subscribe((btn: NavbarBtn) => {

        if (!btn) return;

        switch (btn.action) {
          case 'filter':
            this.isExpandFilter = !this.isExpandFilter;
            break;
          case 'search':
            this.is_openSearch = !this.is_openSearch;
            break;
        }
      })
    );
  }

  private setSearchForm() {
    this.searchForm = this.fb.group({
      search: [""]
    });

    this.subscription.add(this.searchForm.controls['search'].valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.isSearchActive = true),
      delay(300),
      switchMap((str: string) => {
        this.params.key = str;
        this.params.skip = 0;
        return this.thirdPartyService.getAllOrdersForAdmin(this.params);

      })).subscribe((res: any) => {

        this.isSearchActive = false;
        this.salesData = res.ResponseData;
        this.getAllOrdersSummary();
      }));
  }

  private setFilterForms() {
    let today = new Date();

    this.filterForm = this.fb.group({
      date: [null],                       // dropdown
      fromDate: [null],                   // for custom range
      toDate: [null],
      saleType: ['']
    });

    this.params.fromDate = moment().subtract(7, 'days').startOf('day').toISOString();
    this.params.toDate = moment().endOf('day').toISOString();

    this.filterForm.patchValue({
      date: 'week',
      fromDate: this.formatDateForInput(moment().subtract(7, 'days').toDate()),
      toDate: this.formatDateForInput(today),
    });

    // Listen for dropdown change
    this.filterForm.get('date')?.valueChanges.subscribe(value => {
      this.onDateFilterChange(value);
    });
  }

  private onDateFilterChange(filterType: string) {
    const today = new Date();

    if (filterType === 'today') {
      this.applyPresetDates(today, today);
    }
    else if (filterType === 'week') {
      const lastWeek = new Date();
      lastWeek.setDate(today.getDate() - 7);
      this.applyPresetDates(lastWeek, today);
    }
    else if (filterType === 'month') {
      const lastMonth = new Date();
      lastMonth.setMonth(today.getMonth() - 1);
      this.applyPresetDates(lastMonth, today);
    }
    else if (filterType === 'custom') {
      // User can choose dates manually
      this.filterForm.patchValue({
        fromDate: '',
        toDate: ''
      });
    }
  }

  private applyPresetDates(from: Date, to: Date) {
    const startOfDay = new Date(from);
    startOfDay.setHours(0, 0, 0, 0);

    const endOfDay = new Date(to);
    endOfDay.setHours(23, 59, 59, 999);

    this.filterForm.patchValue({
      fromDate: this.formatDateForInput(startOfDay),
      toDate: this.formatDateForInput(endOfDay)
    });

    this.params.fromDate = startOfDay.toISOString();     // 2025-11-20T00:00:00.000Z
    this.params.toDate = endOfDay.toISOString();         // 2025-11-27T23:59:59.999Z
  }



  private getAllOrdersList() {
    this.loading = true;
    this.thirdPartyService.getAllOrdersForAdmin(this.params).subscribe({
      next: (res: any) => {
        this.isLazyloading = false;
        this.salesData = res.ResponseData;
        this.getAllOrdersSummary();
        if (res.ResponseData.length < this.params.take) {
          this.isEndOfList = true;
        }
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
      }
    });
  }

  private getAllOrdersSummary() {
    this.summaryLoading = true;
    this.thirdPartyService.getAllOrdersSummary(this.params).subscribe({
      next: (res: any) => {
        if (res?.Result === 'Success' && res?.ResponseData) {
          this.summary = res.ResponseData;
        }
        this.summaryLoading = false;
      },
      error: (err) => {
        console.error('Error fetching service summary:', err);
        this.summaryLoading = false;
      },
    });
  }

  formatDateForInput(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  formatUnixToReadable(unixTimestamp: number): string {
    if (!unixTimestamp) return '';

    return moment.unix(unixTimestamp).format('DD MMM YY, hh:mm a');
  }
}
